<template>
    <div>
        <h1>This is a linkedin component</h1>
    </div>
</template>

<script>
export default {
    data: function () {
        return {}
    }
}
</script>

<style scoped>

</style>
